export const CONTACT = {
  phone: "+91 8390860276",
  email: "amgroupofeducation@gmail.com",
  whatsapp: "https://wa.me/918390860276",
  instagram: "https://www.instagram.com/am_group_of_education?igsi=cTZxaHQ3YWJwbDVx",
};

export const STATS_HERO = [
  { value: 10000, suffix: "+", label: "Students Enrolled", icon: "user-graduate" },
  { value: 100,   suffix: "+", label: "Courses Offered",   icon: "book-open" },
  { value: 50,    suffix: "+", label: "Expert Faculty",    icon: "chalkboard-user" },
  { value: 24,    suffix: "/7", label: "Online & Offline Learning", icon: "globe" },
];

export const STATS = STATS_HERO;

// ------------------- SCHOOL COURSES -------------------
export const SCHOOL_CLASSES = [
  "1st Standard","2nd Standard","3rd Standard","4th Standard","5th Standard",
  "6th Standard","7th Standard","8th Standard","9th Standard","10th Standard",
];
export const BOARDS = [
  { code: "SSC",  name: "SSC",  desc: "Maharashtra State Board — English & Semi-English medium." },
  { code: "CBSE", name: "CBSE", desc: "Central Board of Secondary Education — Nationally aligned syllabus." },
  { code: "ICSE", name: "ICSE", desc: "Indian Certificate of Secondary Education — English medium excellence." },
];
export const SCHOOL_SUBJECTS = [
  { name: "Mathematics",     icon: "square-root-variable" },
  { name: "Science",         icon: "flask" },
  { name: "English",         icon: "book-open-reader" },
  { name: "Hindi",           icon: "language" },
  { name: "Marathi",         icon: "feather" },
  { name: "Social Science",  icon: "earth-asia" },
  { name: "History",         icon: "landmark-dome" },
  { name: "Geography",       icon: "mountain-sun" },
  { name: "Civics",          icon: "scale-balanced" },
  { name: "EVS",             icon: "leaf" },
  { name: "Computer",        icon: "laptop" },
  { name: "General Knowledge", icon: "lightbulb" },
];

export const HIGHER_SEC_STREAMS = [
  {
    name: "Science",
    icon: "atom",
    tag: "PCM · PCB · PCMB",
    color: "from-brand-primary to-brand-dark",
    subjects: [
      { name: "Physics",          icon: "bolt" },
      { name: "Chemistry",         icon: "flask" },
      { name: "Mathematics",       icon: "square-root-variable" },
      { name: "Biology",           icon: "dna" },
      { name: "Computer Science",  icon: "microchip" },
      { name: "English",           icon: "book-open-reader" },
    ],
  },
  {
    name: "Commerce",
    icon: "chart-line",
    tag: "Accounts · Economics · BS",
    color: "from-brand-dark to-brand-primary",
    subjects: [
      { name: "Accounts",        icon: "calculator" },
      { name: "Economics",        icon: "coins" },
      { name: "Business Studies", icon: "briefcase" },
      { name: "Mathematics",      icon: "square-root-variable" },
      { name: "Statistics",       icon: "chart-column" },
      { name: "English",          icon: "book-open-reader" },
    ],
  },
];

export const CA_PROGRAM = {
  name: "Chartered Accountancy (CA)",
  icon: "user-tie",
  tag: "Professional Course",
  desc: "Structured coaching for CA aspirants — from Foundation to Final, with career guidance, mock tests and one-on-one mentorship.",
  stages: [
    { name: "CA Foundation",    icon: "seedling" },
    { name: "CA Intermediate",   icon: "layer-group" },
    { name: "CA Final",          icon: "trophy" },
    { name: "Career Guidance",   icon: "compass" },
    { name: "Mock Tests",        icon: "file-pen" },
    { name: "Mentorship",        icon: "handshake" },
  ],
};

// ------------------- COMPETITIVE EXAMS -------------------
export const COMPETITIVE_EXAMS = [
  { title: "NEET", icon: "stethoscope", tag: "Medical Entrance", desc: "Complete NEET-UG coaching with biology specialists, integrated test series and weekly mocks." },
  { title: "JEE (Main + Advanced)", icon: "square-root-variable", tag: "Engineering Entrance", desc: "IIT-level problem solving, PYQ workshops, live doubt clearing and Advanced-tier physics." },
];
export const FOUNDATION_STAGES = [
  { name: "Class 8 Foundation",  icon: "seedling", desc: "Concept-building in Maths & Science with weekly aptitude drills." },
  { name: "Class 9 Foundation",  icon: "leaf",     desc: "Board syllabus + Olympiad-style problem solving." },
  { name: "Class 10 Foundation", icon: "tree",     desc: "Integrated Board + NTSE / entrance early-prep track." },
  { name: "Foundation Program",  icon: "rocket",   desc: "2-year integrated NEET / JEE foundation for Classes 8–10." },
];

// ------------------- GOVERNMENT COURSES -------------------
export const GOVT_CATEGORIES = [
  { title: "UPSC Civil Services", icon: "landmark",      tag: "Civil Services",  desc: "IAS / IPS / IFS foundation, optional subjects, essay writing and interview mentorship." },
  { title: "MPSC Rajyaseva",       icon: "landmark-dome", tag: "MPSC",            desc: "Maharashtra Rajyaseva Pre + Mains + Interview with GS focus." },
  { title: "MPSC Combined",        icon: "layer-group",   tag: "MPSC",            desc: "PSI / STI / ASO combined preparation under one roof." },
  { title: "MPSC Group C",         icon: "users",         tag: "MPSC",            desc: "Clerical / Excise / Sub-Registrar posts — full coverage." },
  { title: "SSC CGL",              icon: "building-columns", tag: "SSC",         desc: "Combined Graduate Level — Tier 1 to Tier 4 complete package." },
  { title: "SSC CHSL",             icon: "building",       tag: "SSC",            desc: "Higher Secondary Level — Tier 1 + Tier 2 typing." },
  { title: "SSC MTS",              icon: "briefcase",      tag: "SSC",            desc: "Multi-Tasking Staff exam prep with speed drills." },
  { title: "IBPS PO",              icon: "landmark",       tag: "Banking",        desc: "Bank Probationary Officer — Pre + Mains + Interview." },
  { title: "IBPS Clerk",           icon: "building-columns", tag: "Banking",     desc: "Bank Clerk exam — Pre + Mains + speed practice." },
  { title: "SBI PO",               icon: "piggy-bank",     tag: "Banking",        desc: "State Bank of India PO — descriptive writing + GD/PI." },
  { title: "SBI Clerk",            icon: "coins",          tag: "Banking",        desc: "SBI Clerical exam — reasoning, quant, English." },
  { title: "RRB NTPC",             icon: "train",          tag: "Railway",        desc: "Non-Technical Popular Categories — CBT 1 & 2." },
  { title: "RRB Group D",          icon: "train-subway",   tag: "Railway",        desc: "Group D level 1 posts — general awareness & aptitude." },
  { title: "Police Bharti",        icon: "shield-halved",  tag: "State",          desc: "Physical + written combined preparation." },
  { title: "Talathi",              icon: "scroll",         tag: "State",          desc: "Revenue department clerical post preparation." },
  { title: "ZP Recruitment",       icon: "people-roof",    tag: "State",          desc: "Zilla Parishad group exams — all cadres." },
  { title: "Forest Department",    icon: "tree",           tag: "State",          desc: "Forest Guard + Range Officer — written & physical." },
  { title: "PSI",                  icon: "user-shield",    tag: "MPSC",           desc: "Police Sub-Inspector — dedicated batch." },
  { title: "STI",                  icon: "id-badge",       tag: "MPSC",           desc: "Sales Tax Inspector — full track." },
  { title: "ASO",                  icon: "file-signature", tag: "MPSC",           desc: "Assistant Section Officer — combined coaching." },
  { title: "NDA",                  icon: "fighter-jet",    tag: "Defence",        desc: "National Defence Academy — written + SSB interview." },
  { title: "CDS",                  icon: "medal",          tag: "Defence",        desc: "Combined Defence Services — Army/Navy/Air Force." },
  { title: "Agniveer",             icon: "flag",           tag: "Defence",        desc: "Agnipath scheme preparation — Army/Navy/Air Force." },
  { title: "CAPF",                 icon: "shield",         tag: "Defence",        desc: "Central Armed Police Forces AC preparation." },
  { title: "TET",                  icon: "chalkboard-user", tag: "Teaching",      desc: "State Teacher Eligibility Test." },
  { title: "CTET",                 icon: "graduation-cap", tag: "Teaching",       desc: "Central Teacher Eligibility Test." },
  { title: "MH SET",               icon: "school",         tag: "Teaching",       desc: "Maharashtra State Eligibility Test for Lectureship." },
  { title: "NET",                  icon: "book-open",      tag: "Teaching",       desc: "UGC National Eligibility Test — JRF prep." },
];

// ------------------- LANGUAGES -------------------
export const LANGUAGES = [
  { name: "Arabic",   flag: "🇸🇦", desc: "Master Modern Standard Arabic for Gulf careers, travel & cultural fluency.", duration: "4 Months" },
  { name: "French",   flag: "🇫🇷", desc: "Speak the language of diplomacy, fashion, and luxury with confidence.", duration: "3 Months" },
  { name: "German",   flag: "🇩🇪", desc: "Open doors to engineering and research opportunities across Europe.", duration: "4 Months" },
  { name: "Chinese",  flag: "🇨🇳", desc: "Mandarin essentials for business, trade and global commerce.", duration: "5 Months" },
  { name: "Russian",  flag: "🇷🇺", desc: "Conversational Russian for academics, tourism and emerging markets.", duration: "4 Months" },
  { name: "Japanese", flag: "🇯🇵", desc: "From Hiragana to fluency — perfect for tech, anime and JLPT prep.", duration: "5 Months" },
  { name: "Marathi",  flag: "🇮🇳", desc: "Speak, read and write Marathi confidently for everyday and exams.", duration: "2 Months" },
];

// ------------------- IT COURSES -------------------
export const IT_COURSES = [
  { name: "C Programming", icon: "c",        brand: true,  duration: "2 Months", level: "Beginner Friendly", desc: "Foundations of programming, memory, and logic building." },
  { name: "C++",           icon: "code",     brand: false, duration: "2 Months", level: "Beginner Friendly", desc: "OOP, STL, problem-solving and competitive programming basics." },
  { name: "Java Basics",   icon: "java",     brand: true,  duration: "3 Months", level: "Beginner Friendly", desc: "Core Java, OOP, collections, and project-based learning." },
  { name: "HTML",          icon: "html5",    brand: true,  duration: "1 Month",  level: "Beginner Friendly", desc: "Structure modern web pages using semantic HTML5." },
  { name: "CSS",           icon: "css3-alt", brand: true,  duration: "1 Month",  level: "Beginner Friendly", desc: "Style, animate, and create responsive layouts with Flexbox & Grid." },
  { name: "JavaScript",    icon: "js",       brand: true,  duration: "2 Months", level: "Beginner Friendly", desc: "Interactivity, DOM, ES6+ and front-end fundamentals." },
];

// ------------------- WHY US / PILLARS -------------------
export const WHY_US = [
  { icon: "user-tie",   title: "Experienced Faculty", desc: "Mentors from top institutions with proven results." },
  { icon: "tag",        title: "Affordable Fees",     desc: "Premium coaching that fits every family budget." },
  { icon: "laptop",     title: "Offline & Online",    desc: "Learn the way you love — hybrid classroom model." },
  { icon: "file-pen",   title: "Weekly Tests",        desc: "Regular assessments tracked with detailed analytics." },
  { icon: "book",       title: "Study Materials",     desc: "Curated notes, DPPs and previous year papers." },
  { icon: "chalkboard", title: "Smart Classrooms",    desc: "Tech-enabled rooms with audio, visuals & live screens." },
  { icon: "compass",    title: "Career Guidance",     desc: "1-on-1 mentorship for stream, college, and exam choices." },
  { icon: "handshake",  title: "Placement Assistance",desc: "Industry tie-ups, mock interviews and job referrals." },
];

export const ABOUT_PILLARS = [
  { icon: "award",        title: "Quality Education",           desc: "Rigorous curriculum, structured revisions and outcome-focused teaching." },
  { icon: "user-tie",     title: "Experienced Mentors",         desc: "Faculty from IITs, medical colleges and civil-services backgrounds." },
  { icon: "trophy",       title: "Competitive Exam Preparation",desc: "Dedicated tracks for NEET, JEE, UPSC, MPSC and every government exam." },
  { icon: "school",       title: "School Coaching",             desc: "SSC · CBSE · ICSE support for Classes 1 – 12 across core subjects." },
  { icon: "language",     title: "Language Courses",            desc: "Arabic, French, German, Chinese, Russian, Japanese & Marathi programs." },
  { icon: "laptop-code",  title: "IT Courses",                  desc: "C, C++, Java, HTML, CSS and JavaScript with hands-on projects." },
  { icon: "medal",        title: "Student Success",             desc: "Thousands of alumni placed at premier institutes and workplaces." },
  { icon: "chalkboard",   title: "Modern Teaching Methods",     desc: "Smart classrooms, live-recorded lectures and analytics-driven tests." },
  { icon: "hands-holding-child", title: "Personalized Mentorship", desc: "One-on-one guidance and doubt sessions with every mentor." },
];

// ------------------- ASSETS -------------------
export const LOGO_SRC = "/brand/logo.png";
export const FOUNDER_SRC = "/brand/founder.jpg";
export const HERO_IMG = "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=1920&q=85";

// ------------------- FOUNDER -------------------
export const FOUNDER = {
  name: "Arif Mulani",
  role: "Founder & Chief Executive Officer (CEO)",
  intro: [
    "Arif Mulani is an educator, mentor, entrepreneur, and visionary leader dedicated to transforming lives through quality education, innovation, and student-centric mentorship. As the Founder & CEO of AM Group of Education, he believes that education is the foundation for building confident individuals, responsible citizens, and future leaders.",
    "Driven by a passion for empowering students, he has created an institution that combines academic excellence with practical learning, career guidance, personality development, and modern teaching methodologies. His vision is to make premium education accessible, affordable, and outcome-driven for every learner.",
  ],
  qualifications: [
    { icon: "🎓", text: "Post Graduate in Political Science & International Relations" },
    { icon: "🎓", text: "Master of Business Leadership & Management" },
    { icon: "🎓", text: "Master of Digital Marketing" },
    { icon: "📱", text: "Social Media Management & Advertisement Expert" },
    { icon: "🎨", text: "Master of Graphics & Content Creation" },
  ],
  civil: [
    "Mr. Arif Mulani has successfully appeared twice for the UPSC Civil Services Examination Interview, one of India's most prestigious and challenging competitive examinations. His journey in Civil Services has strengthened his expertise in governance, leadership, strategic thinking, public administration, current affairs, discipline, and problem-solving.",
    "The knowledge and experience gained through this journey enable him to mentor aspiring students with practical strategies, effective preparation techniques, and the confidence required to excel in competitive examinations and professional careers.",
  ],
  philosophy: "Education is not just about securing marks—it's about building confidence, developing character, inspiring innovation, and creating leaders who can positively transform society.",
  vision: [
    "Under the leadership of Arif Mulani, AM Group of Education is committed to nurturing students through a holistic learning environment that combines academic excellence, skill development, competitive exam preparation, language proficiency, and technology-driven education.",
    "The institution strives to provide every student with personalized mentorship, modern learning resources, career guidance, and unwavering support, ensuring they achieve their highest potential and become confident, ethical, and future-ready individuals.",
  ],
  tagline: "Empowering Minds, Building Futures, Creating Leaders.",
};
